// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r-yR","option":"styles_option__28f1S","active":"styles_active__2vKR6"};